export const dummyAttorney = [
  {
    attorneyName: "Son**nam",
    attorneyLocation: "Seoul",
    priceContent: [
      {
        title: "Provisional Patent Application",
        price: "250,000 KRW",
      },
      {
        title: "Regular Patent Application",
        price: "1750,000 KRW",
      },
    ],
    solutionContent: [
      {
        title: "Problem Situation",
        content: "I was worried that someone might imitate my idea and file a patent application.",
      },
      {
        title: "Solution Direction",
        content: "I received a professional patent guide and safely protected my rights.",
      },
    ],
  },
  {
    attorneyName: "KimHo**",
    attorneyLocation: "Seoul/Gyeonggi",
    priceContent: [
      {
        title: "Provisional Patent Application",
        price: "350,000 KRW",
      },
      {
        title: "Regular Patent Application",
        price: "1950,000 KRW",
      },
    ],
    solutionContent: [
      {
        title: "Problem Situation",
        content: "I need to submit a patent based on my research journal.",
      },
      {
        title: "Solution Direction",
        content: "I received a specialized patent guide for research and safely protected my rights.",
      },
    ],
  },
  {
    attorneyName: "Park**Ji",
    attorneyLocation: "Seoul",
    priceContent: [
      {
        title: "Provisional Patent Application",
        price: "300,000 KRW",
      },
      {
        title: "Regular Patent Application",
        price: "1850,000 KRW",
      },
    ],
    solutionContent: [
      {
        title: "Problem Situation",
        content: "I was unsure about the correct classification of goods for trademark registration.",
      },
      {
        title: "Solution Direction",
        content: "I received expert assistance in classifying goods and confirmed the correct classification for my trademark application.",
      },
    ],
  },
  {
    attorneyName: "Kim**min",
    attorneyLocation: "Seoul",
    priceContent: [
      {
        title: "Provisional Patent Application",
        price: "280,000 KRW",
      },
      {
        title: "Regular Patent Application",
        price: "2000,000 KRW",
      },
    ],
    solutionContent: [
      {
        title: "Problem Situation",
        content: "I had difficulty understanding the technical aspects required for patent application.",
      },
      {
        title: "Solution Direction",
        content: "I received explanations on the technical aspects from experts and proceeded with the application.",
      },
    ],
  },
  {
    attorneyName: "Lee*Hee",
    attorneyLocation: "Seoul",
    priceContent: [
      {
        title: "Provisional Patent Application",
        price: "320,000 KRW",
      },
      {
        title: "Regular Patent Application",
        price: "1950,000 KRW",
      },
    ],
    solutionContent: [
      {
        title: "Problem Situation",
        content: "I don't know how to protect my design with a patent.",
      },
      {
        title: "Solution Direction",
        content: "Received expert assistance for design patent application and safely filed it.",
      },
    ],
  },
];
